import React, { Suspense } from "react";

import type { AdminDashboardChartProps } from "./admin-dashboard-chart-inner";

const LazyAdminDashboardChart = React.lazy(() =>
  import("./admin-dashboard-chart-inner").then((mod) => ({
    default: mod.AdminDashboardChart,
  })),
);

export function AdminDashboardChart(props: AdminDashboardChartProps) {
  const fallbackHeight = props.height ?? 300;

  return (
    <Suspense
      fallback={
        <div
          className="flex w-full items-center justify-center rounded-lg border border-dashed border-muted-foreground/40 text-sm text-muted-foreground"
          style={{ minHeight: fallbackHeight }}
        >
          Loading chart…
        </div>
      }
    >
      <LazyAdminDashboardChart {...props} />
    </Suspense>
  );
}

export type { AdminDashboardChartProps } from "./admin-dashboard-chart-inner";
